import React from "react";
import { BaseApp } from "../base/App";
import { FILM_CONFIG } from "./filmConfig";
import FilmGpt from "./FilmGpt";
import FilmDalle from "./FilmDalle";
import { FilmPosterEditor } from "./FilmPosterEditor";
import { FilmVoice } from "./FilmVoice";
import FilmVideo from "./FilmVideo";

export default function FilmApp() {
  return (
    <BaseApp
      config={FILM_CONFIG}
      components={{
        Gpt: FilmGpt,
        Dalle: FilmDalle,
        PosterEditor: FilmPosterEditor,
        Voice: FilmVoice,
        Video: FilmVideo,
      }}
    />
  );
}
